import StageChange from "Components/StageChange/StageChange";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getLotsTraded,
  getProfitableTime,
  getStatistics,
  getWinRate,
} from "../../../Redux/ChallengePerformance/ChallengePerformanceAction";
import LotsTraded from "./LostsTraded";
import TotalPL from "./TotalPL";
import WinRate from "./WinRate";
import { Skeleton } from "Components/ui/skeleton";
import { getEquityData } from "../../../Redux/ChallengeOverview/ChallengeOverviewAction";
import ChallengeTabs from "Components/ChallengeTabs/ChallengeTabs";
import mt5Icon from "Assets/Images/mt5icon.svg";
import tradelockerIcon from "Assets/Images/tradelockerIcon.svg";
import { useAuth } from "@clerk/clerk-react";
import { useTheme } from "hooks/ThemeContext";
import TradeLockerBlack from "Assets/Images/TradeLockerBlack.svg";

function Overview() {
  const { theme } = useTheme();
  const [lots, setLots] = useState();
  const dispatch = useDispatch();
  const {
    challengeStageInfo,
    challengeCurrency,
    stages,
    challengeStageInfoLoading,
    getWinRateLoading,
    getProfitableTimeLoading,
    getStatisticsLoading,
    equityDataLoading,
  } = useSelector((state) => state.ChallengeOverviewReducer);

  const { winRate, lotsTraded, profitableTime, getLotsTradedLoading } =
    useSelector((state) => state.ChallengePerformanceReducer);
  const { getToken } = useAuth();

  const [currentSeries, setCurrentSeries] = useState("1H");

  useEffect(() => {
    if (challengeStageInfo?.Account?.login) {
      dispatch(
        getWinRate(
          getToken,
          encodeURIComponent(challengeStageInfo?.Account?.login)
        )
      );
      dispatch(
        getLotsTraded(
          getToken,
          encodeURIComponent(challengeStageInfo?.Account?.login)
        )
      );
      dispatch(
        getProfitableTime(
          getToken,

          encodeURIComponent(challengeStageInfo?.Account?.login)
        )
      );
      dispatch(
        getStatistics(
          getToken,
          encodeURIComponent(challengeStageInfo?.Account?.login)
        )
      );
    }
  }, [challengeStageInfo]);
  useEffect(() => {
    if (challengeStageInfo?.Account?.login) {
      dispatch(
        getEquityData(
          getToken,
          encodeURIComponent(challengeStageInfo?.Account?.login),
          {
            filter: currentSeries == "All" ? "ALL" : currentSeries,
          }
        )
      );
    }
  }, [challengeStageInfo, currentSeries]);

  useEffect(() => {
    if (lotsTraded?.totalLots) {
      setLots(lotsTraded?.totalLots);
    }
  }, [lotsTraded]);

  return (
    <div className="w-full">
      <div className="flex flex-col gap-4">
        <div className="flex sm:items-center justify-between sm:flex-row flex-col ">
          <div className="flex items-baseline gap-3 w-fit text-nowrap">
            <div className="text-2xl font-N_Medium flex flex-row gap-4 item-center">
              {!challengeStageInfoLoading &&
                (challengeStageInfo?.Challenge?.Platform?.name?.toLowerCase() ===
                "platform 5" ? (
                  <img src={mt5Icon} alt="mt5" className="w-[0.95rem]" />
                ) : (
                  <img
                    src={theme === "light" ? TradeLockerBlack : tradelockerIcon}
                    alt="tradelockerIcon"
                    className="w-[1.05rem]"
                  />
                ))}
              Challenge {!challengeStageInfoLoading && "-"}{" "}
              {challengeStageInfo?.Account?.login}{" "}
            </div>
          </div>
          <div className=" sm:my-0 my-4 ">
            <StageChange />
          </div>
        </div>{" "}
        <ChallengeTabs page="performance" />
      </div>

      <div className="sm:grid xl:grid-cols-3 sm:grid-cols-2 flex flex-col  gap-4 mt-6">
        <div className="flex flex-col gap-4 w-full h-auto  ">
          {getWinRateLoading || challengeStageInfoLoading ? (
            <div className="chart_cont bg-background border-2 border-border-darkNew rounded-lg h-full flex flex-col relative   p-4 justify-between ">
              <div className="flex justify-between border-b-2 border-b-border-darkNew pb-4  mb-4">
                <div className="text-base">Win Rate</div>

                <Skeleton className="w-16 h-6 " />
              </div>

              <Skeleton className="w-full min-h-[250px]  h-full" />
            </div>
          ) : (
            <WinRate />
          )}
        </div>
        <div className="flex flex-col gap-4 w-full h-auto">
          {getLotsTradedLoading || challengeStageInfoLoading ? (
            <div className="chart_cont bg-background border-2 border-border-darkNew rounded-lg h-full flex flex-col relative   p-4 justify-between ">
              <div className="flex justify-between border-b-2 border-b-border-darkNew pb-4  mb-4">
                <div className="text-base">Total Lots Traded</div>

                <Skeleton className="w-16 h-6 " />
              </div>

              <Skeleton className="w-full min-h-[250px]  h-full " />
            </div>
          ) : (
            <LotsTraded lots={lots} setLots={setLots} />
          )}
        </div>

        <div className="flex flex-col gap-4  w-full h-auto  xl:col-auto col-span-2">
          {equityDataLoading || challengeStageInfoLoading ? (
            <div className="chart_cont bg-background border-2 border-border-darkNew rounded-lg h-full flex flex-col relative   p-4 justify-between ">
              <div className="flex justify-between border-b-2 border-b-border-darkNew pb-4  mb-4">
                <div className="text-base">Total P&L</div>

                <Skeleton className="w-16 h-6 " />
              </div>

              <Skeleton className="w-full min-h-[250px]  h-full" />
            </div>
          ) : (
            <TotalPL
              currentSeries={currentSeries}
              setCurrentSeries={setCurrentSeries}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default Overview;
